var img = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAD1BMVEVHcEyDjY+DjY+DjY+DjY/yB8A3AAAABHRSTlMA5kpJG2qUMwAAAB5JREFUKM9jYBi+wFAYi6CII7GCikKj7hyS7hwIAACYAgNkcvWbUQAAAABJRU5ErkJggg==";
  export default img;